import { parseISO, format } from 'date-fns';
import {
  PhoneNumberUtil,
  PhoneNumberFormat,
  AsYouTypeFormatter,
} from 'google-libphonenumber';
import { GlobalStateProvider, useGlobalState } from '../context/GlobalStateContext';


export function formatPhone(phone: any) {
  const phoneUtil = PhoneNumberUtil.getInstance();
  if (phone) {
    phone = phone.replace(/\D/g, '')
    if (phone && phone.length > 3) {
      if (phone == '56912345678') {
        return '+56 9 1234 5678';
      } else {
        try {
          const number = phoneUtil.parse('+' + phone.toString(), undefined); // No region for initial parse
          return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
        } catch (error) {
          // If parsing fails, it's likely not a recognizable phone number format, return empty string
          return '';
        }
      }
    }
  }
  return '';
}
//const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState();
export function storeCounters(data: any, setInvoicesExpired: (invoicesExpired: number) => void, setPendingAuth: (pendingAuth: number) => void, setShowPropertiesSelector: (token: number) => void) {
  if (data && data.admin && data.admin.properties) {
    setShowPropertiesSelector(data.admin.properties.length)
  }
  if (data && data.admin && data.admin.counters) {
    setInvoicesExpired(data.admin.counters.invoicesExpired)
    setPendingAuth(data.admin.counters.pendingAuth)
  }
}

export function storeJWT(
  data: any,
  globalState: ReturnType<typeof useGlobalState>
) {
  const { setJWT, setServerVersion, setMenu, setPendingAuth, setInvoicesExpired, setShowPropertiesSelector } = globalState;

  if (data?.token) {
    setJWT(data.token);
    localStorage.setItem("JWT", data.token);
  }
if (data && data.admin && data.admin.properties) {
    setShowPropertiesSelector(data.admin.properties.length)
  }
  if (data && data.admin && data.admin.counters) {
    setInvoicesExpired(data.admin.counters.invoicesExpired)
    setPendingAuth(data.admin.counters.pendingAuth)
  }

  if (data && data?.serverVersion) {
    setServerVersion(data.serverVersion)
  }
  if (data && data.admin && data.admin.menu) {
    setMenu(data.admin.menu)
  }

  if (data?.menu && typeof setMenu === 'function') {
    setMenu(data.menu);
    localStorage.setItem("menu", JSON.stringify(data.menu));
  }
}

export function storeJWT2(data: any, setJWT: (token: string) => void, setServerVersion: (token: number) => void, setMenu: (token: any) => void) {
  if (data?.JWT && data?.JWTRenew && data.JWTRenew !== "") {
    console.log("token set:", data.JWTRenew);
    if (data && data.admin && data.admin.counters) {
      console.log(data.admin.counters)
      //const { setPendingAuth } = useGlobalState();
      //setPendingAuth(data.admin.counters.pendingAuth);
      localStorage.setItem('pendingAuth', data.admin.counters.pendingAuth.toString());
      localStorage.setItem('invoicesExpired', data.admin.counters.invoicesExpired.toString());
    }
    setJWT(data.JWTRenew);
  }
  console.log(data.serverVersion)
  if (data && data?.serverVersion) {
    setServerVersion(data.serverVersion)
  }
  if (data && data.admin && data.admin.menu) {
    setMenu(data.admin.menu)
  }
}
export function isEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function getParameter(hash: string, parameter: string) {
  let queryParams = new URLSearchParams();
  let hashNow = hash.substring(1);
  let extractedReturnUrl = ''
  const questionMarkIndex = window.location.hash.indexOf('?');
  if (questionMarkIndex !== -1) {

    hashNow = hashNow.substring(0, questionMarkIndex - 1);
    let queryString = hash.substring(questionMarkIndex + 1);
    queryParams = new URLSearchParams(queryString);
    extractedReturnUrl = queryParams.get(parameter) || '';
  }
  return extractedReturnUrl;
}

export function getHash(hash: string) {

  let hashNow = hash.substring(1);
  const questionMarkIndex = window.location.hash.indexOf('?');
  let queryString = '';
  let queryParams = new URLSearchParams();
  let rUrl: string | null = '';
  if (questionMarkIndex !== -1) {

    hashNow = hash.substring(0, questionMarkIndex);
    queryString = hash.substring(questionMarkIndex + 1);
    queryParams = new URLSearchParams(queryString);
    const extractedReturnUrl = queryParams.get('returnUrl');
    rUrl = extractedReturnUrl;
  }
  return hashNow;
}
export function isValidPhone(phone: any) {
  const phoneUtil = PhoneNumberUtil.getInstance();
  if (phone) {
    phone = phone.replace(/\D/g, '')
    if (phone.length > 3) {
      if (phone == '56912345678') {
        return true;
      } else {
        try {
          const number = phoneUtil.parse('+' + phone.toString(), undefined); // No region for initial parse
          return (phoneUtil.isValidNumber(number)); // Check if it's a possible number for any region
        } catch (error) {
          // If parsing fails, it's likely not a recognizable phone number format, keep disabled
          return false;
        }
      }
    }
  }
  return false;
}


export function isJWTExpired(token: string): boolean {
  if (!token) return true; // No token = expired

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decodedPayload = JSON.parse(atob(base64));

    if (!decodedPayload.exp) {
      return true; // No exp = consider expired
    }
    //const date = new Date(decodedPayload.exp * 1000);
    //console.log(date)
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    return decodedPayload.exp < now;
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return true; // Invalid token = expired
  }
}

/*
export function formatDate(dateString: string): string {
  if (dateString !== '') {
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const year = date.getFullYear();
      console.log(dateString)
      console.log(day)
      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  } else { return '' }
}
  */
export function formatDate(dateString: string): string {
  if (dateString !== '') {
    try {
      const date = parseISO(dateString);
      const formattedDate = format(date, 'dd-MM-yyyy');
      //console.log(dateString);
      //console.log(format(date, 'dd'));
      return formattedDate;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  } else {
    return '';
  }
} 